import { SVButton } from '@/components/core';
import LogoImage from '@/components/LogoImage';
import { ROUTES } from '@/constants/routes';
import { Card, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function ForgotPasswordSuccess() {
  const navigate = useNavigate();

  return (
    <>
      <LogoImage />
      <Card>
        <Stack spacing={2}>
          <Typography variant="h6">A Reset Email Has Been Sent!</Typography>
          <SVButton
            onClick={() => navigate(ROUTES.LOGIN, { replace: true })}
            fullWidth>
            Done
          </SVButton>
        </Stack>
      </Card>
    </>
  );
}
